module.exports = "/assets/47f943d5ac533ea4a71fd25de219d878.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/UM.png
// module id = 1896
// module chunks = 0